export const FUEL_TYPES = [
  "بنزين",
  "ديزل",
  "كهربائي",
  "هجين",
  "غاز",
  "بنزين قابل للشحن",
  "ديزل قابل للشحن",
] as const;

export type FuelType = (typeof FUEL_TYPES)[number];

/** English labels for filters + Add Car. Stored/API values stay Arabic. */
export const FUEL_FILTER_LABELS_EN: Record<FuelType, string> = {
  بنزين: "Bensin",
  ديزل: "Diesel",
  كهربائي: "Electric",
  هجين: "Hybrid",
  غاز: "Gas",
  "بنزين قابل للشحن": "Plug-in Bensin",
  "ديزل قابل للشحن": "Plug-in Diesel",
};
